module.exports = __webpack_public_path__ + "img/handing1.64f690fb.svg";